/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/fetchClient.js";
import type { ResearchChatControllerGetMessageStatusQueryResponse, ResearchChatControllerGetMessageStatusPathParams, ResearchChatControllerGetMessageStatus400, ResearchChatControllerGetMessageStatus401, ResearchChatControllerGetMessageStatus404, ResearchChatControllerGetMessageStatus409, ResearchChatControllerGetMessageStatus500 } from "../types/ResearchChatControllerGetMessageStatus.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/fetchClient.js";

function getResearchChatControllerGetMessageStatusUrl(messageId: ResearchChatControllerGetMessageStatusPathParams["messageId"]) {
  const res = { method: 'GET', url: `/api/research-chat/message/${messageId}/status` as const }
  return res
}

/**
 * @summary Poll message processing status
 * {@link /api/research-chat/message/:messageId/status}
 */
export async function researchChatControllerGetMessageStatus(messageId: ResearchChatControllerGetMessageStatusPathParams["messageId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ResearchChatControllerGetMessageStatusQueryResponse, ResponseErrorConfig<ResearchChatControllerGetMessageStatus400 | ResearchChatControllerGetMessageStatus401 | ResearchChatControllerGetMessageStatus404 | ResearchChatControllerGetMessageStatus409 | ResearchChatControllerGetMessageStatus500>, unknown>({ method : "GET", url : getResearchChatControllerGetMessageStatusUrl(messageId).url.toString(), ... requestConfig })
  return res.data
}